import Button from "./Button";

export default class BlueprintCarousel extends PIXI.Container {

    get index() {
        return this._index;
    }

    constructor(total) {
        super();

        this.signals = {};
        this.signals.selected = new P3.utils.MiniSignal();

        this._tweens = new P3.utils.TWEEN.Group();

        this._index = 0;

        this._spines = new Array(total);
        for (let i = 0; i < this._spines.length; i++) {
            const sp = new PIXI.spine.Spine(P3.assets.spineData("ghost_" + P3.utils.padNum(i + 1, 2)));
            this.addChild(sp);
            sp.visible = false;
            sp.scale.set(0.5);
            this._spines[i] = sp;
        }

        this._spines[0].visible = true;

        const spacing = 310;

        this._leftPanel = new PIXI.Container(); //new PIXI.Sprite(P3.assets.texture("panel_chevron_l"));
        // this._leftPanel.anchor.set(0.5);
        this._leftPanel.position.set(-spacing, 0);
        this.addChild(this._leftPanel);

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_secondary_medium_previous_out');
        states.over = P3.assets.texture('btn_secondary_medium_previous_over');
        states.down = P3.assets.texture('btn_secondary_medium_previous_down');

        this._leftButton = new Button(states);
        //  this._leftButton.clickSoundName = "sfx_next_design_page_00";
        this._leftButton.overSoundName = "sfx_rollover";
        this._leftButton.position.set(-10, 0);
        this._leftButton.signals.click.add(this.onPrevious, this);
        this._leftPanel.addChild(this._leftButton);

        // set hit area
        this._leftButton.hitArea = new PIXI.Rectangle(-this._leftPanel.width * 0.5, -this._leftPanel.height * 0.5, this._leftPanel.width + 20, this._leftPanel.height);

        this._rightPanel = new PIXI.Container(); //new PIXI.Sprite(P3.assets.texture("panel_chevron_r"));
        // this._rightPanel.anchor.set(0.5);
        this._rightPanel.position.set(spacing, 0);
        this.addChild(this._rightPanel);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_secondary_medium_next_out');
        states.over = P3.assets.texture('btn_secondary_medium_next_over');
        states.down = P3.assets.texture('btn_secondary_medium_next_down');

        this._rightButton = new Button(states);
        //    this._rightButton.clickSoundName = "sfx_next_design_page_00";
        this._rightButton.overSoundName = "sfx_rollover";
        this._rightButton.position.set(10, 0);
        this._rightButton.signals.click.add(this.onNext, this);
        this._rightPanel.addChild(this._rightButton);

        // set hit area
        this._rightButton.hitArea = new PIXI.Rectangle(-this._rightPanel.width * 0.5 - 20, -this._rightPanel.height * 0.5, this._rightPanel.width + 20, this._rightPanel.height);

        this._selectButton = P3.Button.create(
            P3.assets.texture("btn_primary_large_out"),
            P3.assets.texture("btn_primary_large_over"),
            P3.assets.texture("btn_primary_large_down"),
            P3.assets.texture("icon_done")
        );
        this._selectButton.clickSoundName = "sfx_select_design_00";
        this._selectButton.overSoundName = "sfx_rollover";
        this._selectButton.position.set(200, 200);
        this._selectButton.signals.click.add(this.onSelect, this);
        this._selectButton.cursor = 'hover';
        this.addChild(this._selectButton);

    }

    destroy(options) {
        super.destroy(options);
        this.signals.selected.detachAll();
    }

    update(dt) {
        this._tweens.update();
        for (let i = 0; i < this._spines.length; i++) {
            if (this._spines[i].visible)
                this._spines[i].update(dt);
        }
    }

    animateOut(callback) {
        this._leftButton.enabled = false;
        this._leftButton.animate = false;

        this._rightButton.enabled = false;
        this._rightButton.animate = false;

        this._selectButton.enabled = false;
        this._selectButton.animate = false;

        new P3.utils.TWEEN.Tween(this._leftButton.scale, this._tweens)
            .to({x: 0, y: 0}, 320)
            .delay(90)
            .easing(P3.utils.TWEEN.Easing.Back.In)
            .start();

        new P3.utils.TWEEN.Tween(this._rightButton.scale, this._tweens)
            .to({x: 0, y: 0}, 320)
            .delay(180)
            .easing(P3.utils.TWEEN.Easing.Back.In)
            .start();

        new P3.utils.TWEEN.Tween(this._selectButton.scale, this._tweens)
            .to({x: 0, y: 0}, 320)
            .delay(270)
            .easing(P3.utils.TWEEN.Easing.Back.In)
            .start();

        new P3.utils.TWEEN.Tween(this, this._tweens)
            .to({alpha: 0}, 320)
            .delay(360)
            .easing(P3.utils.TWEEN.Easing.Quadratic.In)
            .onComplete(_ => callback && callback.call())
            .start();
    }

    onNext() {
        this._spines[this._index].visible = false;
        this._index++;
        if (this._index > this._spines.length - 1) {
            this._index = 0;
        }
        this._spines[this._index].visible = true;
        P3.audio.playSound("sfx_next_design_page_00");
    }

    onPrevious() {
        this._spines[this._index].visible = false;
        this._index--;
        if (this._index < 0) {
            this._index = this._spines.length - 1;
        }
        this._spines[this._index].visible = true;
        P3.audio.playSound("sfx_next_design_page_00");
    }

    onSelect() {
        this.signals.selected.dispatch();
    }
}